import React, {memo} from 'react';
import cn from 'classnames';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {AssaysStatuses, AssaysStatusesColors} from '../../common/types';

export type AssaysListItemProps = { status: AssaysStatuses, name: string }

const useStyles = makeStyles({
  root: {
    padding: 4,
    borderRadius: 5,
    color: 'white',
    fontSize: 14,
    fontWeight: 'bold',
  },
  done: {
    background: AssaysStatusesColors.Done
  },
  inProgress: {
    background: AssaysStatusesColors.InProgress
  },
  notReady: {
    background: AssaysStatusesColors.NotReady,
  }
});

const AssaysListItem = memo(({name, status}: AssaysListItemProps) => {
  const cl = useStyles();
  const className = cn({
    [cl.root]: true,
    [cl.done]: status === AssaysStatuses.Done,
    [cl.inProgress]: status === AssaysStatuses.InProgress,
    [cl.notReady]: status === AssaysStatuses.NotReady,
  });
  return (
    <p className={className}>{name}</p>
  );
});

export default AssaysListItem;